import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { IReview } from '../../../../shared/models/review';
import { UserDataService } from '../../../../shared/services/auth/userData.service';
import { ReviewService } from '../../../../shared/services/review.service';
import { ReviewFullTeamAssessmentComponent } from "../../review-content/review-full-team-assessment/review-full-team-assessment.component";
import { ReviewWitnessInterviewComponent } from "../../review-content/review-witness-interview/review-witness-interview.component";
import { ReviewTeacherStaffInterviewComponent } from '../../review-content/review-teacher-staff-interview/review-teacher-staff-interview.component';
import { ReviewStudentOfConcernInterviewComponent } from '../../review-content/review-student-of-concern-interview/review-student-of-concern-interview.component';
import { ReviewParentInterviewComponent } from '../../review-content/review-parent-interview/review-parent-interview.component';
import { EStage, EStatus, EYesNo } from '../../../../shared/models/types.enum';
import { AssessCaseService } from '../../../../shared/services/assessCase.service';
import { RejectionReasonComponent } from '../../rejection-reason/rejection-reason.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'assessments-review-modal',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    ReviewFullTeamAssessmentComponent,
    ReviewWitnessInterviewComponent,
    ReviewTeacherStaffInterviewComponent,
    ReviewStudentOfConcernInterviewComponent,
    ReviewParentInterviewComponent,
    RejectionReasonComponent
],
  templateUrl: './assessments-review-modal.component.html',
  styleUrl: './assessments-review-modal.component.css'
})
export class AssessmentsReviewModalComponent implements OnInit {
  
  @Input() taskId: string | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSend = new EventEmitter<{type: string, message: string}>();

  icons = Icons;
  statusEnum = EStatus;
  stageEnum = EStage;
  yesNo = EYesNo;

  loading: boolean = false;
  showRejectionReason: boolean = false;

  assessCase: any | null = null;
  currentBuildingId: string | null = null;
  currentForm: { name: string, title: string } = { name: '', title: '' };
  formsList: any[] = [];

  forms = [
    { name: 'full_team_threat_assessment', title: 'Full Team Threat Assessment' },
    { name: 'witness_interview', title: 'Witness Interview' },
    { name: 'teacher_staff_interview', title: 'Teacher/Staff Interview' },
    { name: 'student_of_concern_interview', title: 'Student of Concern Interview' },
    { name: 'parent_interview', title: 'Parent Interview' }
  ]

  constructor(
    private userDataService: UserDataService,
    private assessCaseService: AssessCaseService,
    private reviewService: ReviewService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();

    this.loadAssessCases();
  }

  loadAssessCases(): void {
    if (this.taskId) {
      this.assessCaseService.getAssessCaseByCaseId(this.taskId).subscribe({
        next: (response) => {
          this.assessCase = response;
          this.forms.forEach((form) => {
            if (this.assessCase[form.name] === this.statusEnum.ReviewPending) {
              this.formsList.push(form);
            }
          });
          this.currentForm = this.formsList[0] || { name: '', title: '' };
        },
        error: (error) => {
          console.error('Error loading assess case:', error);
          this.onSend.emit({type: 'failed', message: error.message});
        }
      });
    }
  }

  handleRejectionSubmit(noteFormValue: { note: string }): void {
    const note = noteFormValue.note;
    this.approveAssessment(this.yesNo.No, note);
  }

  approveAssessment(decision: string, note?: string): void {
    if (this.taskId) {
      this.loading = true;
      const data: IReview = {
        case_id: this.taskId,
        building_id: Number(this.currentBuildingId),
        section_review_type: this.stageEnum.Assessments,
        approve: decision,
        note: note || ''
      };
      this.reviewService.reviewCompleted(data, this.currentForm.name).subscribe({
        next: (response) => {
          this.loading = false;
          this.showRejectionReason = false;
          // remove the form object out of the formsList array
          this.formsList = this.formsList.filter(form => form.name !== this.currentForm.name);
          this.currentForm = this.formsList[0] || { name: '', title: '' };
          if (this.formsList.length === 0) {
            this.onSend.emit({type: 'success', message: 'This occurred after rejecting and approving a review.'});
          } else {
            this.toastr.success('Saved successful!', 'Success');
          }
        },
        error: (error) => {
          this.loading = false;
          this.showRejectionReason = false;
          if (this.formsList.length === 0) {
            this.onSend.emit({type: 'failed', message: error.message});
          } else {
            this.toastr.error(error.message, 'Error'); 
          }
          console.error('Error completing review:', error);
        }
      });
    }
  }

  unapprovePlans(): void {
  
  }

  handleCloseReviewModal(): void {
    this.taskId = null;
    this.onClose.emit();
  }
}
